import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'
Vue.use(Vuex);


export default new Vuex.Store({
  plugins: [createPersistedState({
      storage: window.sessionStorage,
  })],
  state: {
    user: {
      loggedIn: false,
      data:null
    }
  },

  getters: {
    user(state){
      return state.user
    }
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    }
  },
  actions: {
    fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        commit("SET_USER", {
          id: user.id,
          email: user.email,
          name: user.name,
          role: user.role
        });
      } else {
        commit("SET_USER", null);
      }
    }
  }
});